import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { equals as t } from "../../../../core/arrayUtils.js";
import { f as s } from "../../../../chunks/vec2f64.js";
import { q as a } from "../../../../chunks/vec2.js";

var i = /*#__PURE__*/function () {
  function i(t, a, _i, c) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    _classCallCheck(this, i);

    this.origin = t, this.axis1 = a, this.factor1 = _i, this.factor2 = c, this.accumulationType = o, this.axis2 = s(a[1], -a[0]);
  }

  _createClass(i, [{
    key: "scale",
    value: function scale(t, s, _i2) {
      a(t.pos, t.pos, this.origin, this.axis1, s), a(t.pos, t.pos, this.origin, this.axis2, _i2);
    }
  }, {
    key: "apply",
    value: function apply(t) {
      this.scale(t, this.factor1, this.factor2);
    }
  }, {
    key: "undo",
    value: function undo(t) {
      this.scale(t, 1 / this.factor1, 1 / this.factor2);
    }
  }, {
    key: "canAccumulate",
    value: function canAccumulate(s) {
      return s instanceof i && t(this.origin, s.origin) && t(this.axis1, s.axis1);
    }
  }, {
    key: "accumulate",
    value: function accumulate(t, s) {
      1 === s.accumulationType ? this.scale(t, s.factor1 / this.factor1, s.factor2 / this.factor2) : this.scale(t, s.factor1, s.factor2);
    }
  }, {
    key: "accumulateParams",
    value: function accumulateParams(t) {
      var s = 1 === t.accumulationType;
      this.factor1 = s ? t.factor1 : this.factor1 * t.factor1, this.factor2 = s ? t.factor2 : this.factor2 * t.factor2;
    }
  }]);

  return i;
}();

export { i as ScaleVertex };